import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
// Colors per state as per design.md §8 — reference CSS vars to avoid duplicating token values
const dayColors = {
    both: 'var(--color-cal-day-both)',
    one: 'var(--color-cal-day-one)',
    none: 'var(--color-cal-day-none)',
    future: 'var(--color-surface-container)',
    today: 'var(--color-primary-container)',
};
const dayBorderColor = {
    both: 'transparent',
    one: 'transparent',
    none: 'transparent',
    future: 'transparent',
    today: 'var(--color-primary)',
};
const dayTextColor = {
    both: 'rgba(255,255,255,0.9)',
    one: 'rgba(255,255,255,0.9)',
    none: 'rgba(255,255,255,0.85)',
    future: 'var(--color-on-surface-variant)',
    today: 'var(--color-primary)',
};
const COL_HEADERS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
export function ComplianceCalendar({ days, studyStartDate }) {
    return (_jsxs("div", { className: "bg-surface-container-low rounded-[12px] p-4 flex flex-col gap-3", children: [_jsxs("p", { className: "text-[12px] font-medium text-on-surface-variant uppercase tracking-[0.06em]", children: ["Scan compliance \u2014 Study started ", studyStartDate] }), _jsx("div", { className: "grid grid-cols-7 gap-1.5", children: COL_HEADERS.map((h) => (_jsx("div", { className: "text-[11px] font-normal text-on-surface-variant text-center py-0.5", children: h }, h))) }), _jsxs("div", { className: "grid grid-cols-7 gap-1.5", children: [days.map((d) => (_jsx("div", { title: `Day ${d.date}`, style: {
                            backgroundColor: dayColors[d.state],
                            borderColor: dayBorderColor[d.state],
                            borderWidth: d.state === 'today' ? 1 : 0,
                            color: dayTextColor[d.state],
                        }, className: "aspect-square rounded-[6px] border border-solid flex items-center justify-center text-[10px] font-semibold leading-none select-none", children: d.date }, d.date))), Array.from({ length: (7 - (days.length % 7)) % 7 }).map((_, i) => (_jsx("div", { className: "aspect-square" }, `pad-${i}`)))] }), _jsx("div", { className: "flex items-center gap-4 flex-wrap pt-1", children: [
                    { state: 'both', label: 'Both scans' },
                    { state: 'one', label: 'One scan' },
                    { state: 'none', label: 'Missed' },
                    { state: 'today', label: 'Today' },
                    { state: 'future', label: 'Upcoming' },
                ].map(({ state, label }) => (_jsxs("div", { className: "flex items-center gap-1.5", children: [_jsx("div", { className: "w-3 h-3 rounded-[3px] border border-solid shrink-0", style: {
                                backgroundColor: dayColors[state],
                                borderColor: dayBorderColor[state],
                                borderWidth: state === 'today' ? 1 : 0,
                            } }), _jsx("span", { className: "text-[11px] font-normal text-on-surface-variant", children: label })] }, state))) })] }));
}
